import { oc } from "@orpc/contract";
import { z } from "zod";

export const FieldFormatSchema = z.enum([
  "string",
  "currency",
  "currency4",
  "date",
  "number",
  "integer",
  "float",
]);

export const FieldSchemaEntrySchema = z.object({
  apiField: z.string(),
  label: z.string(),
  format: FieldFormatSchema,
});

export const GetFieldSchemaResponseSchema = z.object({
  fields: z.array(FieldSchemaEntrySchema),
});

export const e844sdFieldSchemaContracts = {
  getSchema: oc
    .input(z.object({}))
    .output(GetFieldSchemaResponseSchema)
    .route({ method: "GET" }),
} as const;

export type FieldSchemaEntry = z.infer<typeof FieldSchemaEntrySchema>;
export type GetFieldSchemaResponse = z.infer<
  typeof GetFieldSchemaResponseSchema
>;
